import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./translations/en.json";

i18n

  .use(LanguageDetector)

  .use(initReactI18next)

  .init({
    debug: false,
    fallbackLng: "en",
    initImmediate: false,
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: {
        translation: {
          ...en,
        },
      },
    },
  });

export default i18n;
